export interface IPaymentApprovalSettings {
  id?: string;
  countryId?: string;
  userRole?: string;
  stage?: number;
}

export const defaultValue: Readonly<IPaymentApprovalSettings> = {};
